import React from "react";
import Modal from "../../Modal/Modal";

const LinkModal = ({
  isOpen,
  onClose,
  linkUrl,
  setLinkUrl,
  selectedText,
  isEditingExistingLink,
  onApplyLink,
  onCancel
}) => {
  const handleClose = () => {
    if (onCancel) {
      onCancel();
    }
    onClose();
  };

  const handleApply = () => {
    if (onApplyLink && linkUrl) {
      onApplyLink();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={isEditingExistingLink ? "Edit Link" : "Add Link"}
    >
      <div>
        <h3 className="text-lg font-semibold mb-4">Insert Link</h3>
        {selectedText && (
          <p className="text-sm text-gray-600 mb-2">
            Selected text: "{selectedText}"
          </p>
        )}
        <input
          type="url"
          placeholder="Enter URL (e.g., https://example.com)"
          value={linkUrl}
          onChange={(e) => setLinkUrl(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          autoFocus
        />
        <div className="flex justify-end gap-2">
          <button
            onClick={handleClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleApply}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
            disabled={!linkUrl}
          >
            {isEditingExistingLink ? "Update Link" : "Insert Link"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LinkModal;
